import Styles from './AnimatingAvatar.scss';

import Template from './AnimatingAvatar.hbs';
import Avatar from 'views/components/avatar/Avatar.svelte'

export default class AnimatingAvatar extends BaseView {

    initialize({ avatar }) {
        this.setElement(Template({ Styles }))
        this.addSvelteChildView('.js-avatar', Avatar, { avatar })
    }

}